//#region Imports
import { createAction, props } from '@ngrx/store';
import {
    PersonalInformationFirstName,
    PersonalInformationLastName,
    PersonalInformationPhone,
    PersonalInformationAddress,
    PersonalInformation,
    PersonalInformationEmail,
} from './../../interfaces';

//#region Actions ids

enum PersonalInfoFormActions {
    loadPersonalInfoForm = '[Personal Info Form] Load Personal Info Form',
    resetPersonalInfoForm = '[Personal Info Form] Reset Personal Info Form',
    resetPersonalInfoFormAddress = '[Personal Info Form] Reset Personal Info Form Address',
    resetPersonalInfoFormFirstName = '[Personal Info Form] Reset Personal Info Form First Name',
    resetPersonalInfoFormLastName = '[Personal Info Form] Reset Personal Info Form Last Name',
    resetPersonalInfoFormPhone = '[Personal Info Form] Reset Personal Info Form Phone',
    resetPersonalInfoFormEmail = '[Personal Info Form] Reset Personal Info Form Email',
    resetSubmittingPersonalInfoForm = '[Personal Info Form] Reset Submitting Personal Info Form',
    setPersonalInfoForm = '[Personal Info Form] Set Personal Info Form',
    setPersonalInfoFormAddress = '[Personal Info Form] Set Personal Info Form Address',
    setPersonalInfoFormFirstName = '[Personal Info Form] Set Personal Info Form First Name',
    setPersonalInfoFormLastName = '[Personal Info Form] Set Personal Info Form Last Name',
    setPersonalInfoFormPhone = '[Personal Info Form] Set Personal Info Form Phone',
    setPersonalInfoFormEmail = '[Personal Info Form] Set Personal Info Form Email',
    setSubmittingPersonalInfoForm = '[Personal Info Form] Set Submitting Personal Info Form',
    setSubmittingPersonalInfoFormError = '[Personal Info Form] Set Submitting Personal Info Form Error',
    setPersonalInfoFormMarketingOptIn = '[Personal Info Form] Set Marketing Opt In',
    resetPersonalInfoFormMarketingOptIn = '[Personal Info Form] Reset Marketing Opt In'
}

//#region Actions Instances

export const LoadPersonalInfoFormAction = createAction(
    PersonalInfoFormActions.loadPersonalInfoForm
);

export const ResetPersonalInfoFormAction = createAction(
    PersonalInfoFormActions.resetPersonalInfoForm
);

export const ResetPersonalInfoFormAddressAction = createAction(
    PersonalInfoFormActions.resetPersonalInfoFormAddress
);

export const ResetPersonalInfoFormFirstNameAction = createAction(
    PersonalInfoFormActions.resetPersonalInfoFormFirstName
);

export const ResetPersonalInfoFormLastNameAction = createAction(
    PersonalInfoFormActions.resetPersonalInfoFormLastName
);

export const ResetPersonalInfoFormPhoneAction = createAction(
    PersonalInfoFormActions.resetPersonalInfoFormPhone
);

export const ResetPersonalInfoFormEmailAction = createAction(
    PersonalInfoFormActions.resetPersonalInfoFormEmail
);

export const ResetSubmittingPersonalInfoFormAction = createAction(
    PersonalInfoFormActions.resetSubmittingPersonalInfoForm
);

export const SetPersonalInfoFormAction = createAction(
    PersonalInfoFormActions.setPersonalInfoForm,
    props<PersonalInformation>()
);

export const SetPersonalInfoFormAddressAction = createAction(
    PersonalInfoFormActions.setPersonalInfoFormAddress,
    props<PersonalInformationAddress>()
);

export const SetPersonalInfoFormFirstNameAction = createAction(
    PersonalInfoFormActions.setPersonalInfoFormFirstName,
    props<PersonalInformationFirstName>()
);

export const SetPersonalInfoFormLastNameAction = createAction(
    PersonalInfoFormActions.setPersonalInfoFormLastName,
    props<PersonalInformationLastName>()
);

export const SetPersonalInfoFormPhoneAction = createAction(
    PersonalInfoFormActions.setPersonalInfoFormPhone,
    props<PersonalInformationPhone>()
);

export const SetPersonalInfoFormEmailAction = createAction(
    PersonalInfoFormActions.setPersonalInfoFormEmail,
    props<PersonalInformationEmail>()
);

export const SetSubmittingPersonalInfoFormAction = createAction(
    PersonalInfoFormActions.setSubmittingPersonalInfoForm
);

export const SetSubmittingPersonalInfoFormErrorAction = createAction(
    PersonalInfoFormActions.setSubmittingPersonalInfoFormError
);

export const SetPersonalInfoFormMarketingOptInAction = createAction(
    PersonalInfoFormActions.setPersonalInfoFormMarketingOptIn,
    props<{ marketingOptIn: boolean }>()
);

export const ResetPersonalInfoFormMarketingOptInAction = createAction(
    PersonalInfoFormActions.resetPersonalInfoFormMarketingOptIn
);
